// extracted by mini-css-extract-plugin
module.exports = {"icon":"Banner-module__icon___PzkMj","icon--no-title":"Banner-module__icon--no-title___5xQJ1","text":"Banner-module__text___CfBb9","title":"Banner-module__title___gIxgv"};